import languages from "config/languages";
import { useGoogleOptimizeExperimentId } from "contexts/DataContext/hooks";
import { useGoogleOptimize } from "hooks/useGoogleOptimize";

const EXPERIMENT_NAME = "top-menu-abc-test";

export const useTopMenuExperiment = () => {
  const nonEnglishLanguages = Array(...languages.keys()).filter((language) => !language.startsWith("en"));

  const experimentId = useGoogleOptimizeExperimentId(
    EXPERIMENT_NAME,
    nonEnglishLanguages.map((language) => ({
      language,
    }))
  );
  const experimentVariant = useGoogleOptimize(experimentId);
  return Number(experimentVariant);
};
